import { Injectable } from "@angular/core";
import { DwContextService, DwEventService, DwExpressionService, DwMenu, DwMenuCategory, DwMenuExpressionProcessorService, DwSecurityUserService } from "@devwareapps/devware-cap";
import { TOGGLE_BANNER_ANIMATIONS } from './features/shared/actions/toggle-banner-animations.action';
import { MY_PROFILE_ACTION } from './features/shared/actions/my-profile.action';

@Injectable()
export class FitnessMenuProcessorService extends DwMenuExpressionProcessorService {
    constructor(dwExpressionSevice: DwExpressionService,
        dwEventService: DwEventService,
        dwContextService: DwContextService,
        dwUserSecurityService: DwSecurityUserService,
    ) {
        super(dwExpressionSevice, dwEventService, dwContextService, dwUserSecurityService);
    }

    processAllMenus(menus: DwMenu[]): DwMenu[] {
        if (!menus.some(menu => menu.menuKey === MY_PROFILE_ACTION)) {
            const profile = new DwMenu();
            profile.menuKey = MY_PROFILE_ACTION; profile.path = MY_PROFILE_ACTION; profile.url = '/' + MY_PROFILE_ACTION;
            profile.display = 'My Profile'; profile.children = [];
            profile.data = {category: DwMenuCategory.userMenu, showInMenu: true, requireAuthentication: true,
                isAction: true, actionKey: MY_PROFILE_ACTION, routeOrder: 10, iconCssClass: 'fa fa-user',
                actionConfig: {requireValidation: false, redirectAfter: false}};
            menus = [...menus, profile];
        }
        if (menus.some(menu => menu.menuKey === TOGGLE_BANNER_ANIMATIONS)) { return menus; }
        const motion = new DwMenu();
        motion.menuKey = TOGGLE_BANNER_ANIMATIONS;
        motion.path = TOGGLE_BANNER_ANIMATIONS;
        motion.url = '/' + TOGGLE_BANNER_ANIMATIONS;
        motion.display = 'Toggle banner animations';
        motion.children = [];
        motion.data = { category: DwMenuCategory.userMenu, showInMenu: true, requireAuthentication: true,
            isAction: true, actionKey: TOGGLE_BANNER_ANIMATIONS, routeOrder: 1000, iconCssClass: 'fa fa-magic',
            actionConfig: { requireValidation: false, redirectAfter: false } };
        return [...menus, motion];
    }
}
